import { IFormAction, IFormActions } from '../../@types/entityTypes';
import React, { ReactElement } from 'react';
import { useProductLabelBasicAction } from './useProductLabelBasicAction';
import { useProductShortageAction } from './useProductShortageAction';
import { useRaiseAssemblyOrderAction } from './useRaiseAssemblyOrderAction';

export enum ProductFormAction {
  PrintProductLabels = 'PRINT_PRODUCT_LABELS',
  AddToShortageList = 'PRODUCT_ADD_TO_SHORTAGE_LIST',
  RaiseAssemblyOrder = 'RAISE_ASSEMBLY_ORDER',
}

export const productFormActionsForPermissions: IFormActions = [
  {
    actionReference: ProductFormAction.PrintProductLabels,
    description: 'Print Product Labels',
  },
  { actionReference: ProductFormAction.AddToShortageList },
  { actionReference: ProductFormAction.RaiseAssemblyOrder },
];

export const useProductFormActions: () => [Array<IFormAction<ProductFormAction>>, ReactElement] = () => {
  const [printProductLabelAction, printProductLabelModals] = useProductLabelBasicAction();
  const [addToShortageListAction, addToShortageListModals] = useProductShortageAction();
  const [raiseAssemblyOrderAction] = useRaiseAssemblyOrderAction();

  return [
    [
      printProductLabelAction as IFormAction<ProductFormAction>, //Narrowing type as the same hook is also used for the workspace action.
      addToShortageListAction,
      raiseAssemblyOrderAction,
    ],
    <>
      {printProductLabelModals}
      {addToShortageListModals}
    </>,
  ];
};
